// Pure gating logic for the /mapa debug panel. Extracted so the rules can be
// covered by unit + prod-build e2e tests without mounting the full route.

export type MapaDebugFlag = {
  enabled_global?: boolean;
  user_ids?: string[];
  tenants?: string[];
} | null;

export const MAPA_DEBUG_FLAG_KEY = "mapa_debug_feature";

export function isFlagAllowed(
  flag: MapaDebugFlag,
  userId: string | null | undefined,
  tenantId?: string | null,
): boolean {
  if (!flag) return false;
  if (flag.enabled_global === true) return true;
  if (userId && Array.isArray(flag.user_ids) && flag.user_ids.includes(userId)) return true;
  if (tenantId && Array.isArray(flag.tenants) && flag.tenants.includes(tenantId)) return true;
  return false;
}

export function computeDebugAllowed(opts: {
  isDev: boolean;
  isMobile: boolean;
  hasAdmin: boolean;
  hasCatalogEditor: boolean;
  flag: MapaDebugFlag;
  userId: string | null | undefined;
  tenantId?: string | null;
}): boolean {
  const { isDev, isMobile, hasAdmin, hasCatalogEditor, flag, userId, tenantId } = opts;
  const flagAllowed = isFlagAllowed(flag, userId, tenantId);
  const roleOrFlag = isMobile
    ? hasAdmin
    : hasAdmin || hasCatalogEditor || flagAllowed;
  return isDev || roleOrFlag;
}
